export const FINANCING_ENDING_POLLING_INTERVAL_MS = 5_000;
